import { Box, SxProps, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  sx?: SxProps;
  children: React.ReactNode;
}

export const PageContent: React.FC<IProps> = ({ sx, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        padding: '0 70px',
        display: 'flex',
        minHeight: 0,
        flex: 1,

        [`@media (min-width: 1366px)`]: {
          padding: '0 30px 20px 30px',
        },
        [`@media (max-width: 1366px)`]: {
          padding: '0 30px',
        },
        [theme.breakpoints.down('md')]: {
          paddingLeft: '20px',
          paddingRight: '20px',
          flexDirection: 'column',
          alignItems: 'flex-start',
        },
        [theme.breakpoints.down('xs')]: {
          marginTop: '0',
          paddingBottom: 0,
          marginBottom: 0,
        },

        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
